import React, { useMemo, useState } from "react";
import "./AddZonesPopup.scss";
import Cookies from "js-cookie";
import { postZone, fetchData, appendZone } from "../../APICalls/GetRequests";
import Popup from "../../UI/Popup";
import NestedPipeSelector from "../NestedPipeSelector/NestedPipeSelector";

const AddZonesPopup = ({
  isVisible,
  field,
  pipes,
  handleCloseAddZonesPopup,
  setZones,
}) => {
  const [selectedGateIds, setSelectedGateIds] = useState([]);
  const [zoneName, setZoneName] = useState("");
  const [successMessage, setSuccessMessage] = useState("");

  const fieldPipes = useMemo(
    () => (pipes || []).filter((p) => p.field_id === field.id),
    [pipes, field.id]
  );


  const allGates = useMemo(
    () =>
      fieldPipes.flatMap((pipe) =>
        pipe.gates.map((g) => ({
          ...g,
          pipeId: pipe.id,
          pipeLocalId: pipe.local_id,
          pipeName: pipe.name,
        }))
      ),
    [fieldPipes]
  );

  const selectedGates = useMemo(
    () => selectedGateIds.map((id) => allGates.find((g) => g.id === id)).filter(Boolean),
    [selectedGateIds, allGates]
  );

  const handleSubmit = async () => {
    if (!zoneName || selectedGateIds.length === 0) return;

    const token = Cookies.get("session_key");
    const payload = { field_id:field.id, gate_ids: selectedGateIds, name:zoneName };

    try {
      await postZone(payload, token); // matches earlier usage: postZone(body, token)
      if (setZones) {
        const zones = await fetchData("allZones", token);
        setZones(zones);
      }
      setSuccessMessage("Zone successfully created. Please close this popup.");
    } catch (err) {
      console.error("Error creating zone:", err);
    }
  };

  const handleRemoveGate = (id) => setSelectedGateIds((prev) => prev.filter((g) => g !== id));

  return (
    <Popup
      isVisible={isVisible}
      isSaveDisabled={!zoneName || selectedGateIds.length === 0}
      headerText="Add Gates to Zone"
      saveButtonText="Add Zone"
      handleClose={handleCloseAddZonesPopup}
      handleSave={handleSubmit}
      popupContent={(
        <div>
          <div className="form-group-input">
            <label>Zone Name:</label>
            <input type="text" value={zoneName} onChange={(e) => setZoneName(e.target.value)} />
          </div>

          <div className="form-group">
            <label>Select Pipes & Gates</label>
            <NestedPipeSelector
              pipes={fieldPipes}
              selectedGateIds={selectedGateIds}
              onChange={setSelectedGateIds}
            />
          </div>

          {selectedGates.length > 0 && (
            <div className="selected-pipes-container">
              {selectedGates.map((gate) => (
                <div key={`selected-gate-${gate.id}`} className="selected-pipe">
                  {`Pipe ${gate.pipeLocalId} - Gate ${gate.local_id}`}
                  <button
                    type="button"
                    className="remove-pipe-button"
                    onClick={() => handleRemoveGate(gate.id)}
                  >
                    X
                  </button>
                </div>
              ))}
            </div>
          )}
          {successMessage && <div className="success-message">{successMessage}</div>}
        </div>
      )}
    />
  )
};

export default AddZonesPopup;
